<dialog #player class="launch-video" aria-labelledby="launch-video-title" (cancel)="close($event)" (click)="backdrop($event)">
  <ng-container *ngIf="video as film">
    <header>
      <app-logo></app-logo>
      <button type="button" class="close-video" aria-label="Close video" (click)="close()" autofocus><span aria-hidden="true">×</span></button>
    </header>
    <h1 id="launch-video-title">{{ film.title }}</h1>
    <p class="description">{{ film.description }}</p>
    <video controls playsinline preload="metadata" [poster]="film.poster" [src]="film.file" [attr.aria-label]="film.title">
      Your browser cannot play this video. <a [href]="film.file">Open the video</a>.
    </video>
    <footer><a href="mailto:info@hostelhop.io">Contact Hostel Hop</a><button type="button" (click)="close()">Continue on Hostel Hop</button></footer>
  </ng-container>
</dialog>
